module.exports = __webpack_public_path__ + "img/newchris-79.48070396.jpg";